export default {"src":"/_next/static/media/0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359.318daa0c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};